import index from './index.json';

export default {
  index,
};
